import "./style.css";
import Alpine from "alpinejs";
import htmx from "htmx.org";
import "flowbite";

import login from "./alpine/login.js";
import sidebar from "./alpine/sidebar.js";
import workflowFilters from "./alpine/workflow_filters.js";
import workflowModal from "./alpine/workflow_modal.js";
import receiptModal from "./alpine/receipt_modal.js";
import reportModal from "./alpine/report_modal.js";
import userModal from "./alpine/user_modal.js";
import bulkSelect from "./alpine/bulk_select.js";
import autoRefresh from "./alpine/auto_refresh.js";

const savedCollapsed = localStorage.getItem("sidebar-collapsed");
Alpine.store("sidebar", { collapsed: savedCollapsed === "true" });

Alpine.data("login", login);
Alpine.data("sidebar", sidebar);
Alpine.data("workflowFilters", workflowFilters);
Alpine.data("workflowModal", workflowModal);
Alpine.data("receiptModal", receiptModal);
Alpine.data("reportModal", reportModal);
Alpine.data("userModal", userModal);
Alpine.data("bulkSelect", bulkSelect);
Alpine.data("autoRefresh", autoRefresh);

window.Alpine = Alpine;
window.htmx = htmx;

Alpine.start();
